import React from 'react';
import './signup-home-screen.scss';
import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';
import { GIFS, PNGS, SVGS } from '@zonofi/gandalf-components';
import { useSignupHomeScreen } from '@zonofi/gandalf-utilities';

export const SignupHomeScreen: React.FC = () => {
  const {
    companyName,
    logoutUser,
    navigateToRetrainScreen,
    navigateToTestScreen,
  } = useSignupHomeScreen();

  return (
    <div className="signup-home-screen">
      <div className="signup-home-screen-header">
        <div className="signup-home-screen-header-left">
          <img
            src={PNGS.Factory}
            alt=""
            className="signup-home-screen-header-left-icon"
          />
          <div className="signup-home-screen-header-left-text">
            <span className="signup-home-screen-header-left-text-greeting primary-font-regular">
              Hello{' '}
              <span role="img" aria-label="wave">
                👋
              </span>
            </span>
            <span className="signp-home-screen-header-left-text-company primary-font-bold">
              {companyName}
            </span>
          </div>
        </div>
        <div className="signup-home-screen-header-right">
          <img
            src={SVGS.LogoutIcon}
            alt=""
            className="signup-home-screen-header-right-icon"
            onClick={logoutUser}
          />
        </div>
      </div>
      <div className="signup-home-screen-agent">
        <div className="signup-home-screen-agent-strip" />
        <div className="signup-home-screen-agent-content">
          <img
            src={GIFS.ExcitedRobot}
            alt=""
            className="signup-home-screen-agent-content-gif"
          />
          <div className="signup-home-screen-agent-content-text">
            <span className="signup-home-screen-agent-content-text-heading primary-font-bold">
              Your AI Agent is ready to test!
            </span>
            <span className="signup-home-screen-agent-content-text-description primary-font-regular">
              This is a Demo Section to show you how AI on WhatsApp will work.
              Please click on Test Agent to experience the product in action
            </span>
          </div>
          <div className="signup-home-screen-agent-content-buttons">
            <ZoButton
              className="train-agent-btn"
              onClick={navigateToRetrainScreen}
              label={'Train Agent'}
            />
            <ZoButton
              className="test-agent-btn"
              onClick={navigateToTestScreen}
              label={'Test Your Agent'}
            />
          </div>
        </div>
      </div>
      <div className="signup-home-screen-why">
        <span className="signup-home-screen-why-heading primary-font-bold">
          WHY TRAIN AGENT
        </span>
        <div className="signup-home-screen-why-body">
          <div className="signup-home-screen-why-body-item">
            <span className="signup-home-screen-why-body-item-heading primary-font-bold">
              15M
            </span>
            <span className="signup-home-screen-why-body-item-description primary-font-regular">
              businesses in India use WhatsApp Business to connect with
              customers.
            </span>
          </div>
          <div className="signup-home-screen-why-body-item">
            <span className="signup-home-screen-why-body-item-heading primary-font-bold">
              98%
            </span>
            <span className="signup-home-screen-why-body-item-description primary-font-regular">
              open rate for WhatsApp messages in India, higher than email and
              SMS.
            </span>
          </div>
        </div>
        <div className="signup-home-screen-why-body">
          <div className="signup-home-screen-why-body-item">
            <span className="signup-home-screen-why-body-item-heading primary-font-bold">
              62%
            </span>
            <span className="signup-home-screen-why-body-item-description primary-font-regular">
              of Indian consumers shop through WhatsApp and other messaging
              apps.
            </span>
          </div>
          <div className="signup-home-screen-why-body-item">
            <span className="signup-home-screen-why-body-item-heading primary-font-bold">
              70%
            </span>
            <span className="signup-home-screen-why-body-item-description primary-font-regular">
              of abandoned carts are recovered using WhatsApp campaigns.
            </span>
          </div>
        </div>
      </div>
      <div className="signup-home-screen-zoknow">
        <div className="signup-home-screen-zoknow-text">
          <span className="signup-home-screen-zoknow-text-heading primary-font-bold">
            <img src={SVGS.PlayIcon} alt="" />
            Watch product videos
          </span>
          <span className="signup-home-screen-zoknow-text-description primary-font-regular">
            We’ll generate a secure magic link that restores your current state
            on desktop.
          </span>
        </div>
        <div className="signup-home-screen-zoknow-link primary-font-regular">
          <a
            href="https://www.zotok.ai/zoknow"
            target="_blank"
            rel="noreferrer"
          >
            https://www.zotok.ai/zoknow
          </a>
          <img src={SVGS.NewTabIcon} alt="" width={16} height={16} />
        </div>
      </div>
    </div>
  );
};
